import { useEffect, useState } from "react";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { _RequestMaintenance, _single } from "../../../../../../core/services/dataBean/EntityCatalog";
import { SelectMachines } from "../../../../../Factoty&Production/Maintenance/Machines/SelectMachines";
import { BasicButton } from "../../../../../theme/Component/BasicButton";
import { toast } from "react-toastify";
import { PrintJson } from "../../../../../theme/Component/PrintJson";

interface ProcedureFunctions {
    _exportMap: Function;
    _procedure: any;
    _pocessData?: any;
    _pushInfo?: Function;
    _pushProps?: Function;
}


interface Props {
    configProcedure: ProcedureFunctions;
}

export const MD001 = ({ configProcedure }: Props) => {

    const { instance, bean, setBean } = useDataBean(_RequestMaintenance);
    const [props, setProps] = useState<any>({});

    useEffect(() => {
        if (configProcedure?._pocessData?.Props) {
            setProps(configProcedure?._pocessData?.Props)
        }
    }, [configProcedure?._pocessData])


    const onExportMap = (obj?: any) => {
        const procedure = configProcedure?._procedure;

        const now = new Date();
        const currentHour = now.getHours();
        const currentMinute = now.getMinutes();

        instance.updateRequestMaintenance({
            AlphaCodeProcedure: procedure.AlphaCode,
            IDProceudreIMP: procedure.IDProcedureImp,
            IDEmployee: props.IDAccount,
            ReportDate: _single.getCurrenDate(),
            ReportTimeH: currentHour,
            ReportTimeM: currentMinute,
            Observations: bean.Obs,
            IDMachines: props.IDMachines ? props.IDMachines : bean.IDMachines,
            IDLocation: props.IDLocation ? props.IDLocation : bean.IDLocation,
            IDMachineName: props.Description ? props.Description : bean.Description,
            IDLocationName: props.IDLocationRender ? props.IDLocationRender : bean.IDLocationRender,
            LocationName: props.IDLocationRender ? props.IDLocationRender : bean.IDLocationRender,
            State: 1,
        }).then(
            (resp) => {
                if (configProcedure?._pushInfo) {
                    configProcedure?._pushInfo(_single.jsonToBootstrapTable({
                        "Maquina": props.Description ? props.Description : bean.Description,
                        "Codigo Interno": props.CodeMachine ? props.CodeMachine : bean.CodeMachine,
                        "Marca": props.Brand ? props.Brand : bean.Brand,
                        "Serial": props.Serial ? props.Serial : bean.Serial,
                        "Ubicación": props.IDLocationRender ? props.IDLocationRender : bean.IDLocationRender,
                        "Falla": bean.Obs,
                    }));
                }
                if (configProcedure?._exportMap) {
                    configProcedure?._exportMap(bean);
                }
                if (configProcedure?._pushProps) {
                    configProcedure?._pushProps({
                        AlphaCodeProcedure: procedure.AlphaCode,
                        IDProceudreIMP: procedure.IDProcedureImp,
                        IDEmployee: props.IDAccount,
                        ReportDate: _single.getCurrenDate(),
                        ReportTimeH: currentHour,
                        ReportTimeM: currentMinute,
                        IDMachines: props.IDMachines ? props.IDMachines : bean.IDMachines,
                        IDLocation: props.IDLocation ? props.IDLocation : bean.IDLocation,
                        IDMachineName: props.Description ? props.Description : bean.Description,
                        LocationName: props.IDLocationRender ? props.IDLocationRender : bean.IDLocationRender,
                        IDLocationName: props.IDLocationRender ? props.IDLocationRender : bean.IDLocationRender,
                    });
                }
            }
        ).catch(
            err => { toast.error("No se pudo realizar la accion") }
        )
    };


    return (
        <div className="row">
            {props.IDMachines ?
                <>
                    <div className="col-md-12">
                        <h5>Maquina Seleccionada</h5>
                    </div>
                    <div className="col-lg-6 my-2">
                        <strong>Codigo Interno:</strong>
                        <div dangerouslySetInnerHTML={{ __html: `${props.CodeMachine}` }}></div>
                    </div>
                    <div className="col-lg-6 my-2">
                        <strong>Maquina:</strong>
                        <div dangerouslySetInnerHTML={{ __html: `${props.Description}` }}></div>
                    </div>
                    <div className="col-lg-6 my-2">
                        <strong>Marca:</strong>
                        <div dangerouslySetInnerHTML={{ __html: `${props.Brand}` }}></div>
                    </div>
                    <div className="col-lg-6 my-2">
                        <strong>Serial:</strong>
                        <div dangerouslySetInnerHTML={{ __html: `${props.Serial}` }}></div>
                    </div>
                    <div className="col-lg-6 my-2">
                        <strong>Ubicación:</strong>
                        <div dangerouslySetInnerHTML={{ __html: `${props.IDLocationRender}` }}></div>
                    </div>
                </>
                :
                <div className="col-md-12">
                    <SelectMachines idSelector={bean.IDMachines} onChange={(e) => { setBean({ ...bean, ...e }) }} label="Seleccione una Maquina" returnType="Object" />
                </div>
            }
            <div className="col-md-12">
                <label>Descripción de la Falla</label>
                <textarea className="form-control" value={bean.Obs} onChange={(e) => { setBean({ ...bean, Obs: e.target.value }) }} />
            </div>
            <div className="col-md-12 mt-4">
                <BasicButton eventClick={onExportMap} icon="ri-send-plane-line" children={`Enviar Informe`} />
            </div>
        </div>
    )
}